import { useEffect, useState } from "react";
import patientController from "../../../../../apis/Controllers/PatientController/patient.controller";
import { Toaster } from "../../../../Helper/toaster/Toaster";
import Validation from "../../../../Helper/validations/vaildation";
import { useLocation, useNavigate } from "react-router-dom";
import wardController from "../../../../../apis/Controllers/WardController/ward.controller";
import rolesController from "../../../../../apis/Controllers/RolesController/roles.controller";
import bedsController from "../../../../../apis/Controllers/BedsControoler/beds.controller";
import { actionsController } from "../../../../../apis/Controllers/CommonController/action.controller";
import roomsController from "../../../../../apis/Controllers/RoomsController/rooms.controller";
import departmentController from "../../../../../apis/Controllers/DepartmentController/department.controller";

const AddPatientFunctions = () => {
    const breadcrumData = ['Dashboard', 'Manage Patient'];
    const breadcrumItem = ['Add Patient'];
    const [currentTab, setCurrentTab] = useState('1');
    const tabs = [
        {
            id: 1,
            tabTitle: 'Demographic Detail',
        },
        {
            id: 2,
            tabTitle: 'Address',
        },
        {
            id: 3,
            tabTitle: 'Consultant',
        },
        {
            id: 4,
            tabTitle: 'General',
        }
    ];

    const defaultValues = {
        stepOne: {
            hospitalId: null,
            uhId: null,
            patientName: null,
            ward: null,
            roomNo: null,
            bedNo: null,
            patientStatus: null,
            patientType: null,
            emergencyAdmission: 0,
            fatherOrHusbandName: null,
            motherName: null,
            dob: null,
            gender: null,
            bloodGroup: null,
            age: null,
            martialStatus: null,
            occupation: null,
            nationality: null,
            adharNumber: null,
            step: 1,
        },
        stepTwo: {
            address: null,
            area: null,
            pincode: null,
            districtData: null,
            stateData: null,
            cityData: null,
            contactNumber: null,
            alternativeNumber: null,
            email: null,
            steps: 2
        },
        stepThree: {
            department : null,
            consultantId: null,
            caseTitle: null,
            tag: null,
            summary: null,
            steps: 3
        },
        stepFour: {
            temperature: null,
            weight: null,
            heartBeat: null,
            bloodPressureTop: null,
            bloodPressureBottom: null,
            oxygenSaturationTop: null,
            oxygenSaturationBottom: null,
            bloodSuger: null,
            steps: 4
        },

    };

    const defaultErrors = {
        uhId: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        patientName: {
            rules: ["required", "alphabetic"],
            isValid: true,
            message: "",
        },
        ward: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        roomNo: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        bedNo: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        patientStatus: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        patientType: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        fatherOrHusbandName: {
            rules: ["required", "alphabetic"],
            isValid: true,
            message: "",
        },
        motherName: {
            rules: ["required", "alphabetic"],
            isValid: true,
            message: "",
        },
        dob: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        gender: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        bloodGroup: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        age: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        martialStatus: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        occupation: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        nationality: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        adharNumber: {
            rules: ["required", "numeric", "max:12", "min:12"],
            isValid: true,
            message: "",
        },
        emergencyAdmission: {
            rules: [""],
            isValid: true,
            message: "",
        },
        //---------second step----------
        address: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        area: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        pincode: {
            rules: ["required", "max:6"],
            isValid: true,
            message: "",
        },
        districtData: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        stateData: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        cityData: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        contactNumber: {
            rules: ["required", "max:13", "min:8"],
            isValid: true,
            message: "",
        },
        alternativeNumber: {
            rules: ["required", "max:13", "min:8"],
            isValid: true,
            message: "",
        },
        email: {
            rules: ["required", "email"],
            isValid: true,
            message: "",
        },
        //<------------------three step---------
        department: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        consultantId: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        caseTitle: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        tag: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        summary: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        //<---------Fourt step -------
        temperature: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        weight: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        heartBeat: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        bloodPressureTop: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        bloodPressureBottom: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        oxygenSaturationTop: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        oxygenSaturationBottom: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        bloodSuger: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
    };


    const [values, setValues] = useState(defaultValues);
    const [isError, setError] = useState(defaultErrors);
    const [loader, setLoader] = useState(false);
    const [wardsList, setWardsList] = useState([]);
    const [roomsList, setRoomsList] = useState([]);
    const [bedsList, setbedsList] = useState([]);
    const [bloodGroupsList, setBloodGroupsList] = useState([]);
    const [martialStatusList, setMartialStatusList] = useState([]);
    const [patientTypesList, setPatientTypesList] = useState([]);
    const [gendersList, setGendersList] = useState([]);
    const [nationalitiesList, setNationalitiesList] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const [districtsList, setDistrictsList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [patientId, setPatientId] = useState(null);
    const loaction = useLocation();
    const navigate = useNavigate();


    useEffect(() => {
        if (values && values.stepOne && values.stepOne.ward) {
            let id = values.stepOne.ward.id ? values.stepOne.ward.id : ''
            getRoomsListing(id);
        }
    }, [values.stepOne.ward]);


    useEffect(() => {
        if (values && values.stepOne && values.stepOne.roomNo) {
            let id = values.stepOne.roomNo.id ? values.stepOne.roomNo.id : ''
            getBedsListing(id);
        }
    }, [values.stepOne.roomNo]);


    useEffect(() => {
        if (values && values.stepTwo && values.stepTwo.stateData) {
            let id = values.stepTwo.stateData.id ? values.stepTwo.stateData.id : ''
            getDistrictsListing(id);
            getCitiesListing(id);
        }
    }, [values.stepTwo.stateData]);


    let Validations = new Validation(isError);

    const handleChange = (field, value, step) => {
        let node = Validations.validateField(field, value);
        setError({ ...isError, [field]: node });
        if (
            value instanceof Date ||
            value instanceof Object ||
            value instanceof Array ||
            typeof value == 'boolean'
        ) {
            setValues({
                ...values,
                [step]: {
                    ...values[step],
                    [field]: value ? value : null,
                },
            });
        } else {
            setValues({
                ...values,
                [step]: {
                    ...values[step],
                    [field]: value,
                },
            });
        }
    };


    const handleEmergencyStatus = (e) => {
        let status = { ...values.stepOne.emergencyAdmission }
        if (e.target.checked === true) {
            status = 1
        }
        else {
            status = 0
        }
        handleChange('emergencyAdmission', status, 'stepOne')
    };


    const handleSubmitStepOne = async () => {
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values.stepOne);
        if (isValid && !isValid.haveError) {
            setLoader(true);
            let response = await patientController.patientCreateStepOne(values.stepOne);
            if (response && response.status) {
                new Toaster().success(response.message);
                setCurrentTab('2');
                setValues(defaultValues);
                setLoader(false);
                setPatientId(response.data.id);
                getPatientDetail(response.data.id);
            } else {
                setLoader(false);
            }
        } else {
            setError({ ...isValid.errors });
        }
    };


    const getPatientDetail = async (id) => {
        setLoader(true);
        let response = await patientController.patientDetail(id);
        if (response && response.status) {
            let data = response.data
            setLoader(false);
            setValues({
                ...values,
                stepOne: {
                    uhId: data && data.uh_id ? data.uh_id : null,
                    patientName: data && data.patient_name ? data.patient_name : null,
                    ward: data && data.cases && data.cases.length > 0
                        ?
                        {
                            "id": data.cases[0].ward_id ? data.cases[0].ward_id : null,
                            "label": data.cases[0].ward_title ? data.cases[0].ward_title : null,
                        }
                        : null,
                    roomNo: data && data.cases && data.cases.length > 0
                        ?
                        {
                            "id": data.cases[0].room_id ? data.cases[0].room_id : null,
                            "label": data.cases[0].room_title ? data.cases[0].room_title : null,
                        }
                        : null,
                    bedNo: data && data.cases && data.cases.length > 0
                        ?
                        {
                            "id": data.cases[0].bed_id ? data.cases[0].bed_id : null,
                            "label": data.cases[0].bed_number ? data.cases[0].bed_number : null,
                        }
                        : null,
                    patientType: data && data.cases && data.cases.length > 0
                        ?
                        {
                            "id": data.cases[0].bed_id ? data.cases[0].patient_type : null,
                            "label": data.cases[0].bed_number ? data.cases[0].patient_type : null,         //<----------------patient type title pending from backend
                        }
                        : null,
                    patientStatus: data && data.patient_status ? data.patient_status : null,
                    EmergencyAdmission: data && data.cases && data.cases.length > 0 ? data.cases[0].emergency_admission : null,
                    //---------------------------------------------------------------------------------------------------------
                    fatherOrHusbandName: data && data.father_name ? data.father_name : null,
                    motherName: data && data.mother_name ? data.mother_name : null,
                    dob: data && data.dob ? data.dob : null,
                    gender: data && data ? { id: data.gender_id, title: data.gender } : null,
                    bloodGroup: data && data ? { id: data.blood_group_id, label: data.blood_group } : null,
                    age: data && data.age ? data.age : null,
                    martialStatus: data && data ? { id: data.marital_status_id, label: data.marital_status } : null,
                    occupation: data && data.occupation ? data.occupation : null,
                    nationality: data && data ? { id: data.nationlity_id, label: data.nationlity_name } : null,
                    adharNumber: data && data.adhaar_card ? data.adhaar_card : null,

                }
            });
        }
        else {
            setLoader(false);
        }
    };

    const handleSubmitStepTwo = async () => {
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values.stepTwo);
        if (isValid && !isValid.haveError) {
            setLoader(true);
            let response = await patientController.patientCreateStepTwo(patientId,values.stepOne, values.stepTwo);
            if (response && response.status) {
                new Toaster().success(response.message);
                setCurrentTab('3');
                getPatientDetail()
                setLoader(false);
            } else {
                setLoader(false);
            }
        } else {
            setError({ ...isValid.errors });
        }
    };


    const handleSubmitStepThree = async () => {
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values.stepThree);
        if (isValid && !isValid.haveError) {
            setLoader(true);
            let response = await patientController.patientCreateStepThree(patientId,values.stepOne, values.stepThree);
            if (response && response.status) {
                new Toaster().success(response.message);
                setCurrentTab('4');
                // getPatientDetail()
                setLoader(false);
            } else {
                setLoader(false);
            }
        } else {
            setError({ ...isValid.errors });
        }
    };


    const patientStatusListing = [
        {
            id: 1,
            title: 'Admitted',
            value: 'admitted',
        },
        {
            id: 2,
            title: 'Under Treatment',
            value: 'under_treatment',
        },
        {
            id: 3,
            title: 'Critical',
            value: 'critical',
        },
        {
            id: 4,
            title: 'Discharge',
            value: 'discharge',
        },
    ];


    const getWardsListing = async () => {
        let response = await wardController.wardListing();
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setWardsList(data);
        }
        else {
            setWardsList([]);
        }
    };


    const getRoomsListing = async (id) => {
        let post = {
            ward_id: id ? id : ''
        }
        let response = await roomsController.roomListing(post);
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setRoomsList(data);
        }
        else {
            setRoomsList([]);
        }
    };


    const getBedsListing = async (id) => {
        let post = {
            room_id: id ? id : ''
        }
        let response = await bedsController.bedsListing(post);
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].bed_number
            }
            setbedsList(data);
        }
        else {
            setbedsList([]);
        }
    };


    const getBoodGroupListing = async () => {
        let response = await actionsController.bloodGroups();
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setBloodGroupsList(data);
        }
        else {
            setBloodGroupsList([]);
        }
    };


    const getMartialStatusListing = async () => {
        let response = await actionsController.martialStatusList();
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setMartialStatusList(data);
        }
        else {
            setMartialStatusList([]);
        }
    };


    const getPatientTypesListing = async () => {
        let response = await actionsController.patientTypes();
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setPatientTypesList(data);
        }
        else {
            setPatientTypesList([]);
        }
    };


    const getGendersListing = async () => {
        let response = await actionsController.gendersList();
        if (response && response.status) {
            setGendersList(response.data);
        }
        else {
            setGendersList([]);
        }
    };


    const getNationalitiesListing = async () => {
        let response = await actionsController.nationalities();
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setNationalitiesList(data);
        }
        else {
            setNationalitiesList([]);
        }
    };


    const getStatesListing = async (id) => {
        let post = {
            country_id: id ? id : ''
        }
        let response = await actionsController.statesList(post);
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setStatesList(data);
        }
        else {
            setStatesList([]);
        }
    };


    const getDistrictsListing = async (id) => {
        let post = {
            state_id: id ? id : ''
        }
        let response = await actionsController.districtsList(post);
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setDistrictsList(response.data);
        }
        else {
            setDistrictsList([]);
        }
    };


    const getCitiesListing = async (id) => {
        let post = {
            state_id: id ? id : ''
        }
        let response = await actionsController.citiesList(post);
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setCitiesList(response.data);
        }
        else {
            setCitiesList([]);
        }
    };


    const getDepartmentsListing = async () => {
        let response = await departmentController.departmentListing();
        if (response && response.status) {
            let data = response.data
            for (let i in data) {
                data[i]['label'] = data[i].title
            }
            setDepartmentList(response.data);
        }
        else {
            setDepartmentList([]);
        }
    };


    const handleRoomNoDropdown = () => {
        if ((values && values.stepOne) && (values.stepOne.ward === null)) {
            new Toaster().error('Please select ward');
        }
        else return;
    };


    const handleBedNoDropdown = () => {
        if ((values && values.stepOne) && (values.stepOne.roomNo === null)) {
            new Toaster().error('Please select Room Number');
        }
        else return;
    };


    const handleDistrictAndCityDropDown = () => {
        if ((values && values.stepTwo) && (values.stepTwo.stateData === null)) {
            new Toaster().error('Please select State');
        }
        else return;
    };


    return {
        breadcrumData,
        breadcrumItem,
        currentTab,
        setCurrentTab,
        tabs,
        values,
        setValues,
        isError,
        handleChange,
        getPatientDetail,
        navigate,
        loaction,
        loader,
        getWardsListing,
        getRoomsListing,
        getBedsListing,
        getBoodGroupListing,
        getMartialStatusListing,
        getPatientTypesListing,
        getNationalitiesListing,
        getStatesListing,
        getGendersListing,
        getDepartmentsListing,
        patientStatusListing,
        wardsList,
        roomsList,
        bedsList,
        bloodGroupsList,
        martialStatusList,
        patientTypesList,
        nationalitiesList,
        gendersList,
        statesList,
        districtsList,
        citiesList,
        departmentList,
        handleEmergencyStatus,
        handleRoomNoDropdown,
        handleBedNoDropdown,
        handleSubmitStepOne,
        handleSubmitStepTwo,
        handleSubmitStepThree,
        handleDistrictAndCityDropDown,
    }
};

export default AddPatientFunctions;